// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileStories-module--container--U4rIi","story":"MobileStories-module--story--1XLRl"};